import IMask from 'imask';
import { ContactForm } from './contact-form.js';
import { privacyInit } from './privacy.js';
import { contactWidgetInit } from './contact-widget';

const contactForm = new ContactForm(
    'contact-form',
    'success-result',
    'error-result',
    '/contact'
);
if (document.getElementById('contact-form')) {
    contactForm.init();
}

window.ContactWidgetConfig = { phone: '', telegram: '@eugenynosenko', email: 'info@toprogram.ru' };
contactWidgetInit();
privacyInit();

const elementPhone = document.getElementById('phone');
if (elementPhone) {
    new IMask(elementPhone, {
        mask: '+7(000)000-00-00',
        lazy: true,
    });
}

const elementEmail = document.getElementById('email');
if (elementEmail) {
    new IMask(elementEmail, {
        mask(value) {
            if (/^[a-z0-9_\.-]+$/i.test(value)) return true;
            if (/^[a-z0-9_\.-]+@$/i.test(value)) return true;
            if (/^[a-z0-9_\.-]+@[a-z0-9-]+$/i.test(value)) return true;
            if (/^[a-z0-9_\.-]+@[a-z0-9-]+\.$/i.test(value)) return true;
            if (/^[a-z0-9_\.-]+@[a-z0-9-]+\.[a-z]{1,6}$/i.test(value)) return true;
            if (/^[a-z0-9_\.-]+@[a-z0-9-]+\.[a-z]{1,6}\.$/i.test(value)) return true;
            if (/^[a-z0-9_\.-]+@[a-z0-9-]+\.[a-z]{1,6}\.[a-z]{1,6}$/i.test(value)) return true;
            return false;
        },
        lazy: false,
    });
}

const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach((link) => {
    link.addEventListener('click', (event) => {
        const targetSelector = link.getAttribute('href');
        const targetElement = targetSelector ? document.querySelector(targetSelector) : null;

        if (!targetElement) {
            return;
        }

        event.preventDefault();
        targetElement.scrollIntoView({
            behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
            block: 'start',
        });

        if (window.location.hash !== targetSelector) {
            window.history.pushState(null, '', targetSelector);
        }
    });
});

const burger = document.getElementById('burger');
const nav = document.getElementById('nav');
if (burger && nav) {
    burger.addEventListener('click', () => {
        burger.classList.toggle('open');
        nav.classList.toggle('open');
        document.body.style.overflow = nav.classList.contains('open') ? 'hidden' : '';
    });

    nav.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
            burger.classList.remove('open');
            nav.classList.remove('open');
            document.body.style.overflow = '';
        });
    });
}

if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                io.unobserve(entry.target);
            }
        });
    }, { threshold: 0.12 });

    document.querySelectorAll('.reveal').forEach((element) => io.observe(element));
} else {
    document.querySelectorAll('.reveal').forEach((element) => element.classList.add('is-visible'));
}

const layer = document.getElementById('pixelLayer');
const hero = document.querySelector('.hero');
if (layer && hero) {
    const pixels = [];
    const PIXELS = 60;

    for (let index = 0; index < PIXELS; index += 1) {
        const pixel = document.createElement('div');
        pixel.className = 'pixel';

        const x = Math.random() * 100;
        const y = Math.random() * 100;
        const size = 3 + Math.random() * 5;

        pixel.style.left = `${x}%`;
        pixel.style.top = `${y}%`;
        pixel.style.opacity = (0.25 + Math.random() * 0.45).toFixed(2);
        pixel.style.width = `${size}px`;
        pixel.style.height = `${size}px`;

        layer.appendChild(pixel);
        pixels.push({ element: pixel, baseX: x, baseY: y });
    }

    hero.addEventListener('mousemove', (event) => {
        const rect = hero.getBoundingClientRect();
        const mouseX = ((event.clientX - rect.left) / rect.width) * 100;
        const mouseY = ((event.clientY - rect.top) / rect.height) * 100;

        pixels.forEach((pixel) => {
            const dx = pixel.baseX - mouseX;
            const dy = pixel.baseY - mouseY;
            const dist = Math.sqrt(dx * dx + dy * dy);
            const force = Math.max(0, 20 - dist) / 20;
            const translateX = dx * force * 2;
            const translateY = dy * force * 2;
            pixel.element.style.transform = `translate(${translateX}px, ${translateY}px)`;
        });
    });

    hero.addEventListener('mouseleave', () => {
        pixels.forEach((pixel) => {
            pixel.element.style.transform = '';
        });
    });
}

const chatForm = document.getElementById('chatForm');
const chatInput = document.getElementById('chatInput');
const chat = document.getElementById('chat');
if (chatForm && chatInput && chat) {
    const replies = [
        'Отлично! Уточню детали — какой у вас бюджет и сроки?',
        'Понял задачу. Ориентировочно 2-4 недели. Оставьте контакт, пришлю расчёт.',
        'Звучит интересно! Лучше обсудить голосом. Оставите номер?',
        'Это в нашей экспертизе. Заполните форму ниже — ответим в течение часа.',
    ];

    chatForm.addEventListener('submit', (event) => {
        event.preventDefault();
        const text = chatInput.value.trim();
        if (!text) {
            return;
        }

        const userBubble = document.createElement('div');
        userBubble.className = 'chat__bubble chat__bubble--user';
        userBubble.textContent = text;
        chat.appendChild(userBubble);

        const typing = document.createElement('div');
        typing.className = 'chat__bubble chat__bubble--bot chat__typing';
        typing.innerHTML = '<span></span><span></span><span></span>';
        chat.appendChild(typing);
        chat.scrollTop = chat.scrollHeight;
        chatInput.value = '';

        window.setTimeout(() => {
            typing.remove();
            const botBubble = document.createElement('div');
            botBubble.className = 'chat__bubble chat__bubble--bot';
            botBubble.textContent = replies[Math.floor(Math.random() * replies.length)];
            chat.appendChild(botBubble);
            chat.scrollTop = chat.scrollHeight;
        }, 1100);
    });
}

const calc = document.getElementById('calc');
if (calc) {
    const state = {
        basePrice: 25000,
        minDays: 3,
        maxDays: 3,
        minWeeks: null,
        maxWeeks: null,
        urgentMinDays: 2,
        urgentMaxDays: 2,
        urgentMinWeeks: null,
        urgentMaxWeeks: null,
        extrasPrice: 0,
        extrasWeeks: 0,
        complexityPriceMultiplier: 1,
        complexityTimeMultiplier: 1,
        deadlinePriceMultiplier: 1,
        deadlineTimeMultiplier: 1,
        urgent: false,
    };

    const formatWeeksWord = (weeks) => {
        const lastDigit = weeks % 10;
        const lastTwoDigits = weeks % 100;

        if (lastDigit === 1 && lastTwoDigits !== 11) {
            return 'неделя';
        }

        if ([2, 3, 4].includes(lastDigit) && ![12, 13, 14].includes(lastTwoDigits)) {
            return 'недели';
        }

        return 'недель';
    };

    const formatWeeksRange = (minWeeks, maxWeeks) => {
        if (minWeeks === maxWeeks) {
            return `от ${minWeeks} ${formatWeeksWord(minWeeks)}`;
        }

        return `от ${minWeeks} до ${maxWeeks} ${formatWeeksWord(maxWeeks)}`;
    };

    const formatDaysWord = (days) => {
        const lastDigit = days % 10;
        const lastTwoDigits = days % 100;

        if (lastDigit === 1 && lastTwoDigits !== 11) {
            return 'рабочего дня';
        }

        return 'рабочих дней';
    };

    const formatDaysRange = (minDays, maxDays) => {
        if (minDays === maxDays) {
            return `от ${minDays} ${formatDaysWord(minDays)}`;
        }

        return `от ${minDays} до ${maxDays} ${formatDaysWord(maxDays)}`;
    };

    const calculateTime = () => {
        const hasUrgentDays = state.urgent && state.urgentMinDays !== null && state.urgentMaxDays !== null;
        const hasUrgentWeeks = state.urgent && state.urgentMinWeeks !== null && state.urgentMaxWeeks !== null;
        const minDaysBase = hasUrgentDays ? state.urgentMinDays : state.minDays;
        const maxDaysBase = hasUrgentDays ? state.urgentMaxDays : state.maxDays;
        const minWeeksBase = hasUrgentWeeks ? state.urgentMinWeeks : state.minWeeks;
        const maxWeeksBase = hasUrgentWeeks ? state.urgentMaxWeeks : state.maxWeeks;
        const deadlineTimeMultiplier = (hasUrgentDays || hasUrgentWeeks) ? 1 : state.deadlineTimeMultiplier;

        if (minDaysBase !== null && maxDaysBase !== null) {
            const extraDays = state.extrasWeeks * 5;
            const minDays = Math.max(
                1,
                Math.ceil((minDaysBase + extraDays) * state.complexityTimeMultiplier * deadlineTimeMultiplier)
            );
            const maxDays = Math.max(
                minDays,
                Math.ceil((maxDaysBase + extraDays) * state.complexityTimeMultiplier * deadlineTimeMultiplier)
            );

            return { unit: 'days', min: minDays, max: maxDays };
        }

        const minWeeks = Math.max(
            1,
            Math.ceil((minWeeksBase + state.extrasWeeks) * state.complexityTimeMultiplier * deadlineTimeMultiplier)
        );
        const maxWeeks = Math.max(
            minWeeks,
            Math.ceil((maxWeeksBase + state.extrasWeeks) * state.complexityTimeMultiplier * deadlineTimeMultiplier)
        );

        return { unit: 'weeks', min: minWeeks, max: maxWeeks };
    };

    const formatTimeRange = (time) => {
        if (time.unit === 'days') {
            return formatDaysRange(time.min, time.max);
        }

        return formatWeeksRange(time.min, time.max);
    };

    const calculateEstimate = () => {
        const total = Math.round(
            ((state.basePrice + state.extrasPrice) * state.complexityPriceMultiplier) * state.deadlinePriceMultiplier
        );
        const time = calculateTime();

        return { total, time };
    };

    const getActiveButtonText = (groupName) => {
        const activeButton = calc.querySelector(`.calc__options[data-group="${groupName}"] .calc__option.active`);

        return activeButton ? activeButton.textContent.trim() : '';
    };

    const getActiveExtrasText = () => {
        const extras = Array.from(calc.querySelectorAll('.calc__options[data-group="extras"] .calc__option.active'))
            .map((button) => button.textContent.trim())
            .filter(Boolean);

        return extras.length ? extras.join(', ') : 'не выбрано';
    };

    const updateCalc = () => {
        const { total, time: estimateTime } = calculateEstimate();
        const value = document.getElementById('calcValue');
        const time = document.getElementById('calcTime');

        if (value) {
            value.textContent = `от ${total.toLocaleString('ru-RU')} ₽`;
        }

        if (time) {
            const timeText = formatTimeRange(estimateTime);
            time.textContent = state.urgent ? `срочно — ${timeText}` : timeText;
        }
    };

    const buildCalcRequestText = () => {
        const { total, time: estimateTime } = calculateEstimate();
        const timeText = formatTimeRange(estimateTime);

        return [
            'Заявка из калькулятора.',
            '',
            `Тип задачи: ${getActiveButtonText('type')}`,
            `Дополнительно: ${getActiveExtrasText()}`,
            `Сложность: ${getActiveButtonText('complexity')}`,
            `Срок: ${getActiveButtonText('deadline')}`,
            `Ориентировочная стоимость: от ${total.toLocaleString('ru-RU')} ₽`,
            `Ориентировочный срок: ${state.urgent ? 'срочно, ' : ''}${timeText}`,
            '',
            'Дополнительные детали задачи: ',
        ].join('\n');
    };

    const selectContactService = (service, type) => {
        if (!service) {
            return;
        }

        const otherOption = Array.from(service.options).find((option) => option.textContent.trim() === 'Другое');
        const matchingOption = Array.from(service.options).find((option) => option.textContent.trim() === type);
        service.value = otherOption ? otherOption.value : (matchingOption ? matchingOption.value : service.value);
    };

    const fillContactFormFromCalc = () => {
        const contactFormElement = document.getElementById('contact-form');
        const message = document.getElementById('message');
        const service = document.getElementById('service');
        const type = getActiveButtonText('type');

        if (message) {
            message.value = buildCalcRequestText();
            message.dispatchEvent(new Event('input', { bubbles: true }));
        }

        selectContactService(service, type);

        if (contactFormElement) {
            contactFormElement.scrollIntoView({
                behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
                block: 'start',
            });
        }

        if (message) {
            window.setTimeout(() => message.focus(), prefersReducedMotion.matches ? 0 : 450);
        }
    };

    calc.querySelectorAll('.calc__options').forEach((group) => {
        const multi = group.dataset.multi === 'true';

        group.querySelectorAll('.calc__option').forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();

                if (multi) {
                    button.classList.toggle('active');
                    let extrasPrice = 0;
                    let extrasWeeks = 0;
                    group.querySelectorAll('.calc__option.active').forEach((activeButton) => {
                        extrasPrice += parseInt(activeButton.dataset.add || '0', 10);
                        extrasWeeks += parseFloat(activeButton.dataset.weeksAdd || '0');
                    });
                    state.extrasPrice = extrasPrice;
                    state.extrasWeeks = extrasWeeks;
                } else {
                    group.querySelectorAll('.calc__option').forEach((item) => item.classList.remove('active'));
                    button.classList.add('active');

                    if (group.dataset.group === 'type') {
                        state.basePrice = parseInt(button.dataset.price || '0', 10);
                        state.minDays = button.dataset.minDays ? parseFloat(button.dataset.minDays) : null;
                        state.maxDays = button.dataset.maxDays ? parseFloat(button.dataset.maxDays) : null;
                        state.minWeeks = button.dataset.minWeeks ? parseFloat(button.dataset.minWeeks) : null;
                        state.maxWeeks = button.dataset.maxWeeks ? parseFloat(button.dataset.maxWeeks) : null;
                        state.urgentMinDays = button.dataset.urgentMinDays ? parseFloat(button.dataset.urgentMinDays) : null;
                        state.urgentMaxDays = button.dataset.urgentMaxDays ? parseFloat(button.dataset.urgentMaxDays) : null;
                        state.urgentMinWeeks = button.dataset.urgentMinWeeks ? parseFloat(button.dataset.urgentMinWeeks) : null;
                        state.urgentMaxWeeks = button.dataset.urgentMaxWeeks ? parseFloat(button.dataset.urgentMaxWeeks) : null;
                    }

                    if (group.dataset.group === 'complexity') {
                        state.complexityPriceMultiplier = parseFloat(button.dataset.priceMult || '1');
                        state.complexityTimeMultiplier = parseFloat(button.dataset.timeMult || '1');
                    }

                    if (group.dataset.group === 'deadline') {
                        state.deadlinePriceMultiplier = parseFloat(button.dataset.priceMult || '1');
                        state.deadlineTimeMultiplier = parseFloat(button.dataset.timeMult || '1');
                        state.urgent = button.dataset.urgent === 'true';
                    }
                }

                updateCalc();
            });
        });
    });

    updateCalc();

    const calcContactButton = calc.querySelector('.calc__contact__btn');
    if (calcContactButton) {
        calcContactButton.addEventListener('click', () => {
            fillContactFormFromCalc();
        });
    }
}

const videoWrap = document.getElementById('videoWrap');
const videoModal = document.getElementById('videoModal');
const modalClose = document.getElementById('modalClose');
const videoPlayer = document.getElementById('videoPlayer');

if (videoWrap && videoModal && modalClose && videoPlayer) {
    const closeVideoModal = () => {
        videoModal.classList.remove('open');
        videoPlayer.pause();
        videoPlayer.currentTime = 0;
        document.body.style.overflow = '';
    };

    videoWrap.addEventListener('click', () => {
        videoModal.classList.add('open');
        document.body.style.overflow = 'hidden';
        const playPromise = videoPlayer.play();
        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
        }
    });

    modalClose.addEventListener('click', closeVideoModal);
    videoModal.addEventListener('click', (event) => {
        if (event.target === videoModal) {
            closeVideoModal();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && videoModal.classList.contains('open')) {
            closeVideoModal();
        }
    });
}

require("./ai-assist.js")
